function getStageFromUrl() {
    const url = window.location.href.replace(window.location.pathname, "");
    if (url.includes("dev.io") || url.includes("localhost")) {
      return "dev";  
    }
  
    if(url.includes("staging")) {
        return "staging";  
    }
    return "prod";
  }
  
  export default getStageFromUrl;